<template>
	<div class="com-mid-content text-white">

		<div class="">
			<BlockBox title="收货量数据" enTitle="Harvest data" height="176">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div class="flex align-center flex-wrap text-center text-white text-bold justify-between">
							<div class="leftNumItem2">
								<div class="">
									<div class="base-font-16">今日收货量(kg)</div>
									<div class="base-font-30 bold text-color-blue">{{item.dayWeight}}</div>
								</div>
							</div>
							<div class="leftNumItem2">
								<div class="">
									<div class="base-font-16">本月收货量(kg)</div>
									<div class="base-font-30 bold text-color-green">{{item.monthWeight}}</div>
								</div>
							</div>
							<div class="leftNumItem2">
								<div class="">
									<div class="base-font-16">总收货量(kg)</div>
									<div class="base-font-30 bold text-color-yellow">{{item.allWeight}}</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="加盟商人数统计" enTitle="Totalnumber" height="570">
				<template #content>
					<div style="">

						<div class="" style="position: relative;">
							<div style="position: absolute;left:0;top:0;width:100%;z-index: 999;">
								<div class="flex align-center justify-around">
									<div>
										<div class="midCircle">
											<div class="midInfo text-center">
												<div class="text-bold text-color-blue" style="font-size:28px;">
													{{ item.monthAllianceNum }}
												</div>
												<div class="base-font-14 margin-top-5 ">本月新增门店数(个)</div>
											</div>
											<el-image style="width: 120px; height: 120px" class="roteCircle"
												:src="circleImage" fit="fill"></el-image>
										</div>
									</div>
									<div>
										<div class="midCircle">
											<div class="midInfo text-center">
												<div class="text-bold text-color-green" style="font-size:28px;">{{ item.allAllianceNum }}
												</div>
												<div class="base-font-14 margin-top-5 ">总门店数(个)</div>
											</div>
											<el-image style="width: 120px; height: 120px" class="roteCircle"
												:src="circleImage" fit="fill"></el-image>
										</div>
									</div>

									<div>
										<div class="midCircle">
											<div class="midInfo text-center">
												<div class="text-bold text-color-orange" style="font-size:28px;">{{ item.dayMoney }}
												</div>
												<div class="base-font-14 margin-top-5 ">今日收货金额(元)</div>
											</div>
											<el-image style="width: 120px; height: 120px" class="roteCircle"
												:src="circleImage" fit="fill"></el-image>
										</div>
									</div>
									<div>
										<div class="midCircle">
											<div class="midInfo text-center">
												<div class="text-bold text-color-yellow" style="font-size:28px;">{{ item.allMoney }}</div>
												<div class="base-font-14 margin-top-5 ">总收货金额(元)</div>
											</div>
											<el-image style="width: 120px; height: 120px" class="roteCircle"
												:src="circleImage" fit="fill"></el-image>
										</div>
									</div>



								</div>
							</div>
							<div style="height:540px;" id="main"></div>
						</div>
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="用户趋势" enTitle="User trend" height="186">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div id="chartFwqk" style="height:145px;"></div>
					</div>
				</template>
			</BlockBox>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import echartMixins from "@/utils/resizeMixins";
	import BlockBox from '@/views/components/blockBox'
	// import shengfen from '@/utils/china.json'; //地图包
	import anshun from '@/utils/anshun.json'; //地图包
	// import notice from '@/assets/img/notice.png'
	import {
		centerDataNew
	} from "@/api/api"
	export default {
		name: "cityGreenLand",
		components: {
			BlockBox
		},
		mixins: [echartMixins],
		data() {
			return {
				item: {},
				circleImage: require("../../assets/images/xsd/circle.png"),
				colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],
				ssfwList: [{
						name: '小程序端',
						data: [820, 932, 901, 934, 1290, 1330, 1320, 820, 932, 901, 934, 1290, 1330, 1320, 932, 901,
							934, 1290, 1330, 1320
						]
					},
					{
						name: '微信端',
						data: [520, 532, 901, 334, 290, 330, 1320, 520, 732, 601, 634, 290, 330, 320, 634, 290, 330,
							320, 634, 290, 330, 320
						]
					},
					{
						name: '网站端',
						data: [720, 632, 601, 534, 490, 730, 820, 320, 932, 901, 934, 1290, 1330, 1320, 320, 932, 901,
							934, 1290, 1330
						]
					}
				],
				//编辑
				loading: true,
				data1: [],
				mapDataList: [],
				showDianList: [],
				fjzxCenter:[],
				hszxList:[],
				timerMid:null,
			}
		},
		mounted() {
			this.changeData();
			this.timerMid = setTimeout(() => {
			  this.changeData();
			}, 60000);
			
		},
		  beforeDestroy() {
		    clearTimeout(this.timerMid);
		  },
		methods: {
			changeData() {
				let _self = this
				centerDataNew().then(res => {
					console.log(res, 'resssss')
					_self.item = res.data;
					let centerMap = res.data.centerMap;
					let mapList = res.data.mapList;
					_self.mapDataList = [];
					_self.showDianList = [];

					if (mapList != null && mapList.length > 0) {
						mapList.forEach(obj => {
							_self.mapDataList.push({
								fromName: obj.name,
								toName: centerMap.name,
								coords: [
									[obj.longitude, obj.latitude],
									[centerMap.longitude, centerMap.latitude]
								],
							});
							_self.hszxList.push({
								name:  obj.name,
								value: [obj.longitude, obj.latitude]
							})
						})
					}
					// _self.hszxList.push({
					// 	name:  res.data.centerMap.name,
					// 	value: [res.data.centerMap.longitude, res.data.centerMap.latitude]
					// })
					console.log(_self.mapDataList,'_self.mapDataList')

					_self.$nextTick(function() {
						_self.drawFwqk();
						_self.initCharts();
					});
				});
				// centerData().then(res => {
				// 	_self.item = res.data;
				// 	_self.$nextTick(function() {
				// 		_self.drawFwqk();



				// 	});
				// });
			},
			drawFwqk() {
				this.chart = this.$echarts.init(document.getElementById("chartFwqk"));
				//let data=[{name: "11-01", value: 128},{name: "11-02", value: 158},{name: "11-03", value: 148},{name: "11-04", value: 188},{name: "11-05", value: 168},{name: "11-06", value: 178}]
				let data = this.item.orderList;
				// let data1 = this.item.postingList;
				let dateList = [];
				let dateValue = [];
				// let dateValue1 = [];
				data.forEach(obj => {
					dateList.push(obj.name);
					dateValue.push(obj.value);
				})
				console.log(dateList, 'dateList')
				// console.log(dateValue1,'dateValue1')
				// data1.forEach(obj => {
				// 	dateValue1.push(obj.value);
				// })

				let option = {
					grid: {
						left: '3%',
						right: '3.5%',
						bottom: '3%',
						top: 30,
						containLabel: true
					},
					tooltip: {
						trigger: 'axis'
					},
					// legend: {
					// 	left: 'right'
					// },
					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisTick: {
							show: false,
						},
						data: dateList,
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#2da3ff'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#ffffff',
								fontSize: 10
							}
						}
					},
					series: [{
						name: "加盟商新增",
						type: 'line',
						smooth: true,
						data: dateValue,
						showSymbol: false,
						symbol: 'emptyCircle', // 几何圆
						symbolSize: 5,
						itemStyle: {
							color: '#03DBF4'
						},
						areaStyle: { // 区域填充样式
							color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#03DBF4', // 0% 处的颜色
									},
									{
										offset: 1,
										color: 'rgba(37,234,255,0)' // 100% 处的颜色
									}
								],
								global: false, // 缺省为 false
							}
						},
					}]
				};
				// echart图表自适应
				this.chart.setOption(option)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});
			},
			initCharts() {
				let myChart = echarts.init(document.getElementById('main'));
				// 飞机图标
				// var geoCoordMap = {
				//   西秀区:[105.946169, 26.248323],
				//   平坝区:[106.259942, 26.40608],
				//   '31回收1店':[105.745609, 26.305794],
				//   '31回收2店':[105.768656, 26.056096],
				//   '31回收3店':[105.618454, 25.944248]
				// };
				// var BJData = [
				//   [{name: '平坝区',value:95},{name:"西秀区"}],
				//   [{name: '31回收1店',value:95},{name:"西秀区"}],
				//   [{name: '31回收2店',value:95},{name:"西秀区"}],
				//   [{name: '31回收3店',value:95},{name:"西秀区"}],
				//   [{name: '31回收4店',value:95},{name:"西秀区"}]
				// ];
				// 飞机图标
				var planePath =
					"path://M793.72377536 595.16495828c0-49.90814209 41.52832031-90.36117554 92.69714355-90.36117555S979.11806246 545.21973732 979.11806246 595.16495828c0 49.90814209-41.52832031 90.3982544-92.69714356 90.3982544S793.72377536 645.07310037 793.72377536 595.16495828z m-1e-8-512.13317871c0-49.94522095 41.52832031-90.3982544 92.69714355-90.3982544S979.11806245 33.08655861 979.11806245 83.03177957c0 49.90814209-41.52832031 90.36117554-92.69714353 90.36117553s-92.69714356-40.45303345-92.69714356-90.36117554zM237.54091402 293.89924172c0-33.25973511 27.66082764-60.25314331 61.81045532-60.2531433L793.72377535 233.64609842c34.11254883 0 61.81045533 26.99340821 61.81045533 60.2531433l-1e-8 153.65478517c-71.93298341 14.34951782-123.50967407 76.04873658-123.50967408 147.61093139 0 71.56219481 51.61376952 133.26141358 123.47259522 147.6109314l0 33.14849853C855.53423068 809.18412332 827.83632418 836.17753152 793.72377535 836.17753153L299.35136935 836.17753152C265.23882052 836.17753152 237.54091402 809.18412333 237.54091402 775.92438821l0-482.02514649z m135.81985475-207.08541869l90.06454467-180.75942995c10.34500123-20.76416015 31.92489624-33.92715455 55.61828613-33.92715453L793.72377536-127.87276143c34.11254883 0 61.81045533 26.99340821 61.81045532 60.2531433l0 3.00338743a153.50646973 153.50646973 0 0 0-113.49838258 94.18029787 147.57385254 147.57385254 0 0 0 20.76416016 143.82888793L428.97905489 173.39295511c-21.28326416 0-41.08337404-10.67871093-52.39242554-28.25408936a58.9553833 58.9553833 0 0 1-3.22586057-58.32504272z m245.90698242 284.61730956a32.55523682 32.55523682 0 0 1 12.7922058 22.06192017l-0.29663085 94.77355957-7.82363893 0 26.58554078 24.58328247 27.21588134-23.50799561-8.12026976-0.29663086 1.85394287-80.16448974c-0.18539429-3.33709717-3.44833373-38.82156372-52.20703125-37.449646z m12.7922058 158.95706178L632.05995699 640.03037576c11.27197266 6.82250976 25.21362305 7.97195434 37.56088257 3.15170287l-0.29663088-112.79388427L632.05995699 530.38819437zM515.7065024 609.10660868l9.38095092 33.51928711 4.67193604-6.00677492 70.70938112 38.93280029c3.59664918 1.59439087 44.38339233 18.42819214 65.07339476-19.16976928 0 0-20.65292358 5.33935546-43.45642089-10.60455322l-71.67343139-37.82043457 2.81799316-6.85958863-37.52380372 8.00903322z m-17.87200927-177.23693849l19.72595214 29.77432252 103.26461792-54.98794556 0.11123659-0.92697144c0.44494628-3.81912231 0.96405029-18.83605957-16.09222414-30.03387452L497.83449313 431.90674906zM385.74510714 559.56925516L491.93895481 615.66956643l19.50347898-28.81027221-104.93316649-55.2104187-0.37078858 0.22247313c-2.66967774 1.48315429-17.50122071 10.56747437-20.39337159 27.73498536z m1.63146972-69.85656739c-3.04046631 1.63146972-35.92941284 20.61584473-12.49557496 59.91943359 0 0 3.93035888-16.64840698 29.03274537-28.4765625a2427.55279541 2427.55279541 0 0 0 74.93637086-38.41369628l4.44946288 5.67306517 10.34500122-33.44512938-36.15188598-10.01129152 3.55957031 7.11914063-73.4161377 37.52380371z"
				// 坐标数据的转换
				// var convertData = function(data) {
				//   var res = [];
				//   for (var i = 0; i < data.length; i++) {
				//     var dataItem = data[i];
				//     var fromCoord = geoCoordMap[dataItem[0].name]; // 始发地
				//     var toCoord = geoCoordMap[dataItem[1].name]; // 目的地
				//     if (fromCoord && toCoord) {
				//       res.push({
				//         fromName: dataItem[0].name,
				//         toName: dataItem[1].name,
				//         coords: [fromCoord, toCoord],
				//       });
				//     }
				//   }
				//   return res;
				// };
				const option = {
					// 背景颜色
					// 提示浮窗样式
					tooltip: {
						show: true,
						trigger: 'item', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						},
						alwaysShowContent: false,
						borderColor: 'rgba(0, 0, 0, 0.16);',
						triggerOn: 'mousemove',
						enterable: true, //鼠标是否可进入提示框浮层中
						textStyle: {
							fontSize: '12',
							overflow: 'break'
						},
						formatter: function(params) {
							let str = '';
							// console.log("params:" + JSON.stringify(params).toString());
							// console.log("params:=====" + params.data.fromName);
							str = `<div> ` + params.data.fromName `</div>`;
							return str;
						}
					},

					// 地图配置
					geo: {
						map: 'anshun',
						aspectScale: 1.75, //长宽比,0.75的含义为宽是高的0.75,假如高为100,宽就只有75;0.5的含义就是宽只有高的一半,假如高为100,宽就只有50
						zoom: 1.05, //视觉比例大小,1.2即为原有大小的1.2倍
						roam: true, //是否开启鼠标缩放和平移漫游。默认不开启。可以不用设置,如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。
						top: '20%',
						// regions: [{
						//             name: '湖北', // 省份名称
						//             itemStyle: { // 自定义样式
						//                 areaColor: 'red', // 区域颜色
						//                 borderColor: '#fff', // 边界颜色
						//                 borderWidth: 2, // 边界宽度
						//             },
						//             label: { // 标签样式
						//                 show: true, // 是否显示省份名称
						//                 color: 'white' // 文字颜色
						//             }
						//         }],

						label: {
							// 通常状态下的样式
							normal: {
								show: true,
								textStyle: {
									color: '#fff',
									fontSize: '12',
									// overflow: 'break'
								},
								
							},
							// 鼠标放上去的样式
							emphasis: {
								textStyle: {
									color: '#fff'
								}
							}
						},
						itemStyle: {

							normal: {
								areaColor: '#0c274b',
								borderColor: '#1cccff',
								borderWidth: 1.5,
								shadowBlur: 35,
								shadowColor: 'rgba(28, 204, 255, 0.3)'
							},
							emphasis: {
								areaColor: '#02102b',
								label: {
									color: '#fff'
								}

							}
						},



					},
					series: [{
							type: 'lines', // 路径图
							zlevel: 1, // 相当于分层，zlevel 大的 Canvas 会在上面 zlevel 小的 Canvas 上面
							effect: { // 线特效的配置
								show: true,
								period: 6, // 特效动画的时间
								trailLength: 0.7, // 特效尾迹的长度
								color: '#fff',
								symbolSize: 6, // 特效标记的大小
							},
							lineStyle: {
								color: '#F5A623',
								width: 0,
								opacity: 0.6,
								curveness: 0.2,
							},
							data: this.mapDataList,
						},
						{
							type: 'lines',
							zlevel: 2,
							symbol: ['none', 'arrow'],
							symbolSize: 10,
							effect: {
								show: true,
								period: 6,
								trailLength: 0,
								symbol: planePath,
								symbolSize: 20,
							},
							lineStyle: {
								color: '#15ff15',
								width: 1,
								opacity: 0.6,
								curveness: 0.2,
							},
							data: this.mapDataList,
						},
						{
							name: 'scatter',
							type: 'scatter',
							coordinateSystem: 'geo',
							data:this.hszxList,
							// data: [{
							// 		name: this.item.centerMap.name,
							// 		value: [this.item.centerMap.longitude, this.item.centerMap.latitude]
							// 	}, // 这里的 value 数组中第一个值代表经度，第二个值代表纬度
							// 	// 可以添加更多的点
							// ],
							// symbolSize: 10,file:///E:/workspace/数据看板/rs-hs-31hs-sjkb/public/logo.png
							// symbol: 'image://https://xcx.31hs.cn/layuiadmin/images/mapicon.png', // 图标的图片URL
							symbolSize: 10, // 图标的大小，可以是像素值或者回调函数
							label: {
								normal: {
									formatter: '{b}',
									position: 'bottom',
									textStyle: {
										// color: '#ff1515',
										color: '#F5A623',
										fontSize: '16',
										fontWeight:'bold',
										overflow: 'break',
									
									},
									
									show: true
								},
								emphasis: {
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: '#fff44c'
								}
							}
						},
						

						{
							name: 'scatter',
							type: 'scatter',
							coordinateSystem: 'geo',
							// data:this.hszxList,
							data: [{
									name: this.item.centerMap.name,
									value: [this.item.centerMap.longitude, this.item.centerMap.latitude]
								}, // 这里的 value 数组中第一个值代表经度，第二个值代表纬度
								// 可以添加更多的点
							],
							// symbolSize: 10,file:///E:/workspace/数据看板/rs-hs-31hs-sjkb/public/logo.png
							symbol: 'image://https://xcx.31hs.cn/layuiadmin/images/mapicon.png', // 图标的图片URL
							symbolSize: 30, // 图标的大小，可以是像素值或者回调函数
							label: {
								normal: {
									formatter: '{b}',
									position: 'bottom',
									textStyle: {
										color: '#15ff15',
										fontSize: '18',
										fontWeight:'bold'
										// overflow: 'break'
									},
									
									show: true
								},
								// normal: {
								// 	show: true,
								// 	textStyle: {
								// 		color: '#fff',
								// 		fontSize: '12',
								// 		overflow: 'break'
								// 	},
									
								// },
								emphasis: {
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: '#FFFFFF'
								}
							}
						}
					]
				};
				// 地图注册，第一个参数的名字必须和option.geo.map一致
				echarts.registerMap('anshun', anshun);
				myChart.setOption(option);
				window.addEventListener('resize', function() {
					myChart.resize();
				});
			},


		}
	}
</script>

<style lang="scss">
	.com-mid-content {
		min-height: 500px;
		padding: 40px 5px 15px 5px;
		box-sizing: border-box;

		& .midItemBox {
			width: 15vw;
			box-sizing: border-box;
			height: 110px;
			line-height: 0.6;

			& .zdInfo {
				font-size: 36px;
				padding-top: 20px;

				& .num {
					font-size: 36px;
					font-weight: bold;
				}

				& .item {
					align-items: flex-end;
				}
			}
		}

		.midItemBox.jb1 {
			padding: 27px 0 0 30px;
			background: -webkit-linear-gradient(left, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
			/* Firefox 3.6 - 15 */
			background: linear-gradient(to right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
		}

		.midItemBox.jb2 {
			padding: 27px 30px 0 0;
			background: -webkit-linear-gradient(left, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
			/* Firefox 3.6 - 15 */
			background: linear-gradient(to right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
		}

		.midCircle {
			width: 120px;
			height: 120px;
			border-radius: 50%;
			position: relative;
			box-shadow: 0 0 40px rgba(21, 88, 152, 0.2);
			background: -webkit-linear-gradient(top, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
			/* Firefox 3.6 - 15 */
			background: linear-gradient(to bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));

			.midInfo {
				width: 120px;
				height: 120px;
				position: absolute;
				top: 0;
				left: 0;
				padding-top:30px;
				box-sizing: border-box;
				line-height: 1.1;
			}
		}

		.roteCircle {
			animation: rotateCircle 9s infinite linear;
			-webkit-animation: rotateCircle 9s infinite linear;
			/* Safari 与 Chrome */
		}


	}

	//调整******
	.leftNumItem2 {
		padding-top: 30px;
		width: 29%;
		height: 125px;
		background: url("../../assets/img/dataK.png") center no-repeat;
		background-size: 100% 100%;
		line-height: 1.5;
		box-sizing: border-box;
	}
</style>